import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const getActiveEmpDocsSlice = createSlice({
  name: "ActiveDocs",

  initialState: { empDocsData: [], activeDocLoader: false },
  reducers: {
    setEmployeeActiveDocs: (state: any, action: PayloadAction<any>) => {
      state.empDocsData = action.payload;
    },
    setEmployeeActiveDocsLoader: (state: any, action: PayloadAction<any>) => {
      state.activeDocLoader = action.payload;
    },

    resetEmployeeActiveDocs: (state: any) => {
      state = [];
    },
  },
});

export const {
  setEmployeeActiveDocs,
  resetEmployeeActiveDocs,
  setEmployeeActiveDocsLoader,
} = getActiveEmpDocsSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default getActiveEmpDocsSlice.reducer;
